import {Injectable} from '@angular/core';
import {CommonService} from '../../common/controller/common.service';
import {ApiMessageService} from '../../core/api-message.service';
import {EntitaOrganizzativa} from './entitaorganizzativa.model';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_ANAGRAFICA} from '../../app-routing.module';
import {Observable, of} from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class EntitaOrganizzativaService extends CommonService<EntitaOrganizzativa> {

  public static ROUTE = 'entitaorganizzativa';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): EntitaOrganizzativa {
    return JsonBaseBuilder.jsonToEntitaOrganizzativa(json);
  }

  public getModule(): string {
    return MODULE_ANAGRAFICA;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return EntitaOrganizzativaService.ROUTE;
  }

  public getTable(items: EntitaOrganizzativa[]): Table {
    return Table.buildBaseTable(EntitaOrganizzativa.getTableKeys(), items);
  }

  public existingIdnsip(idnsip: string, entity: EntitaOrganizzativa): Observable<boolean> {
    return this.getBoolean('/existingidnsip', new HttpParams()
      .set('idnsip', idnsip)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public existingSederif(sedeRiferimento: boolean, entity: EntitaOrganizzativa): Observable<boolean> {
    if (entity?.cdsuo && sedeRiferimento) {
      return this.getBoolean('/existingsederif', new HttpParams()
        .set('cdsuo', entity?.cdsuo)
        .set('id', entity?.getId() ? entity?.getId() + '' : '')
        .set('tipo_id', entity?.tipo?.getId() ? entity?.tipo?.getId() + '' : '')
      );
    }
    return of(false);
  }


  public lastIdnsip(tipo: number): Observable<any> {
    return this.getAny('/lastidnsip', new HttpParams()
      .set('tipo', tipo ? tipo + '' : ''));
  }
}
